import { render, staticRenderFns } from "./LocationSub.vue?vue&type=template&id=46ed5d28&"
import script from "./LocationSub.vue?vue&type=script&lang=js&"
export * from "./LocationSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports